import React, { FC } from 'react';

import { BaseProps } from './basepaths.types';
import { BaseRect } from './basepaths.style';
import {
    activeClassname,
    basePathDataValueKey,
} from './constants';

// Retrieve base fill color
const retrieveBaseFill = (
    baseFilled: boolean,
    filledColor: string,
    emptyColor: string
  ): string => {
    return baseFilled ? filledColor : emptyColor;
  }

  // Retrieve base stroke color
  const retrieveBaseStroke = (
    baseFilled: boolean,
    filledColor: string,
    strokeColor: string
  ): string => {
    return baseFilled ? filledColor : strokeColor;
  }

// Retrieve the SVG rect representing the base
const Base: FC<BaseProps> = ({
    filled,
    transform,
    filledColor,
    emptyColor,
    strokeColor,
    baseValue,
    strokeWidth,
    handlers,
    eventsEnabled = true,
    baseLabels,
    className,
}: BaseProps) => {
  const squareSide: string = '6';
  let overrideClassName = filled ? activeClassname : '';

  // Call the handler when the event is triggered
  const invokeHandler: Function = (type: string, e?: Event) => {
    handlers[type](e);
  };
  const handlerProps: object = {};
  const eventKeys: Array<string> = Object.keys(handlers);
  eventKeys.forEach((key: string) => {
    handlerProps[key] = (e: Event) => { invokeHandler(key, e); };
  });

  if (className) {
    overrideClassName += ` ${className}`;
  }

  const hasEvents = eventKeys.length > 0 && eventsEnabled;
  let selectableProps = {};

  if (hasEvents) {
    selectableProps = {
      ['aria-label']: baseLabels[baseValue],
      ['aria-checked']: filled,
      [basePathDataValueKey]: baseValue,
      role: 'checkbox',
      tabIndex: 0,
    };
  }

  return (
    <BaseRect
      className={overrideClassName}
      fill={ retrieveBaseFill( filled, filledColor, emptyColor ) }
      strokeWidth={ strokeWidth }
      stroke={ retrieveBaseStroke( filled, filledColor, strokeColor ) }
      width={ squareSide }
      height={ squareSide }
      transform={ transform }
      rx='1px'
      ry='1px'
      { ...selectableProps }
      { ...handlerProps }
    />
  );
};

export default Base;
